import { Row, Col } from "react-bootstrap";
import { Button, ButtonGroup, Typography, TextField } from "@mui/material";
import { useEffect, useState } from "react";

export default function FragmentOption(props) {
  const { fragmentCount, setFragmentCount } = props;

  const min = 0;
  const max = 50;

  const [inputValue, setInputValue] = useState(String(fragmentCount));

  // Keep input in sync when +/- buttons change the value
  useEffect(() => {
    setInputValue(String(fragmentCount));
  }, [fragmentCount]);

  const clamp = (num) => Math.min(max, Math.max(min, num));

  const handleInputChange = (e) => {
    const next = e.target.value;

    // Allow empty string while typing
    if (next === "") {
      setInputValue("");
      return;
    }

    // Only digits
    if (!/^\d+$/.test(next)) {
      return;
    }

    setInputValue(next);
    setFragmentCount(clamp(Number(next)));
  };

  const handleBlur = () => {
    // If left empty, snap back to min
    if (inputValue === "") {
      setFragmentCount(min);
      setInputValue(String(min));
      return;
    }

    const clamped = clamp(Number(inputValue));
    setFragmentCount(clamped);
    setInputValue(String(clamped));
  };

  return (
    <Col className="slide-option">
      <Row>
        <Col>
          <Row className="mb-3 py-1">
            <Col className="label-container d-flex align-items-center">
              <Typography variant="form-group-label" owner="admin">
                Fragment count
              </Typography>
            </Col>

            <Col>
              <ButtonGroup variant="outlined" size="small">
                <Button
                  className="fragment-count-btn decrease"
                  onClick={() => setFragmentCount((v) => clamp(v - 1))}
                  disabled={fragmentCount <= min}
                >
                  −
                </Button>

                <TextField
                  className="fragment-count-textfield"
                  value={inputValue}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  inputProps={{
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                    style: { textAlign: "center", width: 40 },
                  }}
                  variant="outlined"
                  size="small"
                />

                <Button
                  className="fragment-count-btn increase"
                  onClick={() => setFragmentCount((v) => clamp(v + 1))}
                  disabled={fragmentCount >= max}
                >
                  +
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
        </Col>
      </Row>
    </Col>
  );
}
